// extracted by mini-css-extract-plugin
module.exports = {"main":"ProfilePage_main__2X8ff","content":"ProfilePage_content__1bdRO","card":"ProfilePage_card__2y9m3","description":"ProfilePage_description__20wEw"};